// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.achievements-container {
  padding: 0;
  background: transparent;
  border-radius: 16px;
  transition: all 0.3s ease;
}

.achievements-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  flex-wrap: wrap;
  gap: 16px;
}

.achievements-header h2 {
  font-size: 1.8rem;
  color: #2c3e50;
  margin: 0;
  transition: color 0.3s ease;
  font-weight: 600;
}

.dark-mode .achievements-header h2 {
  color: #f5f5f5;
}

.user-level {
  display: flex;
  align-items: center;
}

.level-badge {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 18px;
  background: linear-gradient(135deg, #f1c40f, #e67e22);
  color: white;
  border-radius: 50px;
  font-weight: 600;
  font-size: 1rem;
  box-shadow: 0 4px 12px rgba(241, 196, 15, 0.3);
}

.level-badge svg {
  font-size: 1.2rem;
}

.dark-mode .level-badge {
  box-shadow: 0 4px 12px rgba(241, 196, 15, 0.4);
}

.stats-overview {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
}

.stat-card {
  background: white;
  padding: 24px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.dark-mode .stat-card {
  background: #2d2d2d;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 255, 255, 0.05);
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
}

.dark-mode .stat-card:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.stat-icon {
  font-size: 2rem;
  color: #3498db;
  margin-right: 16px;
  background: rgba(52, 152, 219, 0.1);
  padding: 12px;
  border-radius: 10px;
}

.dark-mode .stat-icon {
  color: #4CA1D8;
  background: rgba(76, 161, 216, 0.15);
}

.stat-info {
  flex: 1 1;
}

.stat-info h3 {
  font-size: 0.9rem;
  color: #7f8c8d;
  margin: 0 0 8px 0;
  font-weight: 500;
  text-transform: uppercase;
}

.dark-mode .stat-info h3 {
  color: #aaa;
}

.stat-value {
  font-size: 1.6rem;
  font-weight: 700;
  color: #2c3e50;
  line-height: 1.2;
}

.dark-mode .stat-value {
  color: #f5f5f5;
}

.achievements-categories {
  display: flex;
  gap: 12px;
  margin-bottom: 32px;
  overflow-x: auto;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  margin-top: 24px;
}

.dark-mode .achievements-categories {
  border-bottom-color: rgba(255, 255, 255, 0.05);
}

.category-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  background: transparent;
  border: 2px solid #3498db;
  border-radius: 50px;
  color: #3498db;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.category-btn:hover {
  background: rgba(52, 152, 219, 0.1);
}

.dark-mode .category-btn {
  border-color: #4CA1D8;
  color: #4CA1D8;
}

.dark-mode .category-btn:hover {
  background: rgba(76, 161, 216, 0.1);
}

.category-btn.active {
  background: #3498db;
  color: white;
  box-shadow: 0 4px 6px rgba(52, 152, 219, 0.2);
}

.dark-mode .category-btn.active {
  background: #4CA1D8;
  box-shadow: 0 4px 6px rgba(76, 161, 216, 0.3);
}

.achievements-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
}

.achievement-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.dark-mode .achievement-card {
  background: #2d2d2d;
  border-color: rgba(255, 255, 255, 0.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.achievement-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.dark-mode .achievement-card:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.achievement-card.completed {
  border-left: 4px solid #2ecc71;
}

.achievement-icon {
  color: #3498db;
  font-size: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background: rgba(52, 152, 219, 0.1);
  border-radius: 12px;
  position: relative;
  margin-right: 16px;
}

.dark-mode .achievement-icon {
  color: #4CA1D8;
  background: rgba(76, 161, 216, 0.15);
}

.achievement-card.completed .achievement-icon {
  color: #2ecc71;
  background: rgba(46, 204, 113, 0.1);
}

.dark-mode .achievement-card.completed .achievement-icon {
  background: rgba(46, 204, 113, 0.15);
}

.lock-icon {
  position: absolute;
  bottom: -4px;
  right: -4px;
  font-size: 0.9rem;
  background: #f8f9fa;
  border-radius: 50%;
  padding: 2px;
  color: #e74c3c;
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

.dark-mode .lock-icon {
  background: #3d3d3d;
  color: #ff6b6b;
}

.lock-icon.unlocked {
  color: #2ecc71;
}

.dark-mode .lock-icon.unlocked {
  color: #2ecc71;
}

.achievement-top {
  display: flex;
  align-items: center;
  padding: 20px 20px 0;
}

.achievement-info {
  flex-grow: 1;
}

.achievement-info h3 {
  color: #2c3e50;
  margin: 0 0 4px 0;
  font-size: 1.1rem;
  font-weight: 600;
}

.dark-mode .achievement-info h3 {
  color: #f5f5f5;
}

.achievement-info p {
  color: #7f8c8d;
  margin: 0;
  line-height: 1.4;
  font-size: 0.9rem;
}

.dark-mode .achievement-info p {
  color: #bbb;
}

.achievement-details {
  padding: 16px 20px 20px;
}

.achievement-progress {
  margin-bottom: 12px;
}

.progress-bar {
  height: 6px;
  background: #ecf0f1;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 4px;
  transition: background-color 0.3s ease;
}

.dark-mode .progress-bar {
  background: #444;
}

.progress-fill {
  height: 100%;
  transition: width 0.5s ease;
  border-radius: 3px;
}

.progress-text {
  color: #7f8c8d;
  font-size: 0.85rem;
  text-align: right;
}

.dark-mode .progress-text {
  color: #aaa;
}

.achievement-reward {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #f1c40f;
  font-weight: 500;
  margin-top: 12px;
  font-size: 0.9rem;
}

.dark-mode .achievement-reward {
  color: #f1c40f;
}

.reward-icon {
  font-size: 1rem;
}

.completion-date {
  font-size: 0.85rem;
  color: #95a5a6;
  font-style: italic;
  margin-top: 8px;
  text-align: right;
}

.dark-mode .completion-date {
  color: #999;
}

.achievements-summary {
  background: white;
  padding: 24px;
  border-radius: 16px;
  margin-top: 32px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.dark-mode .achievements-summary {
  background: #2d2d2d;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-color: rgba(255, 255, 255, 0.05);
}

.achievements-summary h3 {
  color: #2c3e50;
  margin: 0 0 20px 0;
  font-size: 1.2rem;
  font-weight: 600;
}

.dark-mode .achievements-summary h3 {
  color: #f5f5f5;
}

.summary-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 20px;
}

.summary-item {
  text-align: center;
}

.summary-item span {
  display: block;
  color: #7f8c8d;
  margin-bottom: 8px;
  font-size: 0.9rem;
}

.dark-mode .summary-item span {
  color: #aaa;
}

.summary-item strong {
  font-size: 1.6rem;
  color: #2c3e50;
  font-weight: 700;
}

.dark-mode .summary-item strong {
  color: #f5f5f5;
}

.no-achievements-message {
  grid-column: 1 / -1;
  text-align: center;
  padding: 40px;
  color: #7f8c8d;
  font-size: 1.1rem;
}

.dark-mode .no-achievements-message {
  color: #bbb;
}

@media (max-width: 768px) {
  .achievements-container {
    padding: 0;
  }
  
  .achievements-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  
  .achievements-header h2 {
    font-size: 1.6rem;
  }
  
  .level-badge {
    padding: 8px 16px;
    font-size: 0.95rem;
  }
  
  .stats-overview {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
  }
  
  .stat-card {
    padding: 16px;
  }
  
  .stat-icon {
    font-size: 1.6rem;
    margin-right: 12px;
    padding: 10px;
  }
  
  .stat-value {
    font-size: 1.4rem;
  }
  
  .achievements-categories {
    margin-bottom: 24px;
  }

  .category-btn {
    padding: 8px 16px;
  }
  
  .achievements-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .summary-stats {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

@media (max-width: 480px) {
  .achievement-card {
    flex-direction: column;
  }
  
  .achievement-icon {
    margin-right: 0;
    margin-bottom: 12px;
    width: 40px;
    height: 40px;
    font-size: 1.5rem;
  }
  
  .achievement-info h3 {
    font-size: 1rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/StudyTools/Achievements.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".achievements-container {\n  padding: 0;\n  background: transparent;\n  border-radius: 16px;\n  transition: all 0.3s ease;\n}\n\n.achievements-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.achievements-header h2 {\n  font-size: 1.8rem;\n  color: #2c3e50;\n  margin: 0;\n  transition: color 0.3s ease;\n  font-weight: 600;\n}\n\n.dark-mode .achievements-header h2 {\n  color: #f5f5f5;\n}\n\n.user-level {\n  display: flex;\n  align-items: center;\n}\n\n.level-badge {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 18px;\n  background: linear-gradient(135deg, #f1c40f, #e67e22);\n  color: white;\n  border-radius: 50px;\n  font-weight: 600;\n  font-size: 1rem;\n  box-shadow: 0 4px 12px rgba(241, 196, 15, 0.3);\n}\n\n.level-badge svg {\n  font-size: 1.2rem;\n}\n\n.dark-mode .level-badge {\n  box-shadow: 0 4px 12px rgba(241, 196, 15, 0.4);\n}\n\n.stats-overview {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 24px;\n  margin-bottom: 32px;\n}\n\n.stat-card {\n  background: white;\n  padding: 24px;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.dark-mode .stat-card {\n  background: #2d2d2d;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border-color: rgba(255, 255, 255, 0.05);\n}\n\n.stat-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);\n}\n\n.dark-mode .stat-card:hover {\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n}\n\n.stat-icon {\n  font-size: 2rem;\n  color: #3498db;\n  margin-right: 16px;\n  background: rgba(52, 152, 219, 0.1);\n  padding: 12px;\n  border-radius: 10px;\n}\n\n.dark-mode .stat-icon {\n  color: #4CA1D8;\n  background: rgba(76, 161, 216, 0.15);\n}\n\n.stat-info {\n  flex: 1;\n}\n\n.stat-info h3 {\n  font-size: 0.9rem;\n  color: #7f8c8d;\n  margin: 0 0 8px 0;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.dark-mode .stat-info h3 {\n  color: #aaa;\n}\n\n.stat-value {\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: #2c3e50;\n  line-height: 1.2;\n}\n\n.dark-mode .stat-value {\n  color: #f5f5f5;\n}\n\n.achievements-categories {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 32px;\n  overflow-x: auto;\n  padding-bottom: 8px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  margin-top: 24px;\n}\n\n.dark-mode .achievements-categories {\n  border-bottom-color: rgba(255, 255, 255, 0.05);\n}\n\n.category-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 18px;\n  background: transparent;\n  border: 2px solid #3498db;\n  border-radius: 50px;\n  color: #3498db;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.category-btn:hover {\n  background: rgba(52, 152, 219, 0.1);\n}\n\n.dark-mode .category-btn {\n  border-color: #4CA1D8;\n  color: #4CA1D8;\n}\n\n.dark-mode .category-btn:hover {\n  background: rgba(76, 161, 216, 0.1);\n}\n\n.category-btn.active {\n  background: #3498db;\n  color: white;\n  box-shadow: 0 4px 6px rgba(52, 152, 219, 0.2);\n}\n\n.dark-mode .category-btn.active {\n  background: #4CA1D8;\n  box-shadow: 0 4px 6px rgba(76, 161, 216, 0.3);\n}\n\n.achievements-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 24px;\n  margin-bottom: 32px;\n}\n\n.achievement-card {\n  background: white;\n  border-radius: 16px;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  position: relative;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.dark-mode .achievement-card {\n  background: #2d2d2d;\n  border-color: rgba(255, 255, 255, 0.05);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.achievement-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\n}\n\n.dark-mode .achievement-card:hover {\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n}\n\n.achievement-card.completed {\n  border-left: 4px solid #2ecc71;\n}\n\n.achievement-icon {\n  color: #3498db;\n  font-size: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 50px;\n  height: 50px;\n  background: rgba(52, 152, 219, 0.1);\n  border-radius: 12px;\n  position: relative;\n  margin-right: 16px;\n}\n\n.dark-mode .achievement-icon {\n  color: #4CA1D8;\n  background: rgba(76, 161, 216, 0.15);\n}\n\n.achievement-card.completed .achievement-icon {\n  color: #2ecc71;\n  background: rgba(46, 204, 113, 0.1);\n}\n\n.dark-mode .achievement-card.completed .achievement-icon {\n  background: rgba(46, 204, 113, 0.15);\n}\n\n.lock-icon {\n  position: absolute;\n  bottom: -4px;\n  right: -4px;\n  font-size: 0.9rem;\n  background: #f8f9fa;\n  border-radius: 50%;\n  padding: 2px;\n  color: #e74c3c;\n  box-shadow: 0 1px 2px rgba(0,0,0,0.1);\n}\n\n.dark-mode .lock-icon {\n  background: #3d3d3d;\n  color: #ff6b6b;\n}\n\n.lock-icon.unlocked {\n  color: #2ecc71;\n}\n\n.dark-mode .lock-icon.unlocked {\n  color: #2ecc71;\n}\n\n.achievement-top {\n  display: flex;\n  align-items: center;\n  padding: 20px 20px 0;\n}\n\n.achievement-info {\n  flex-grow: 1;\n}\n\n.achievement-info h3 {\n  color: #2c3e50;\n  margin: 0 0 4px 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.dark-mode .achievement-info h3 {\n  color: #f5f5f5;\n}\n\n.achievement-info p {\n  color: #7f8c8d;\n  margin: 0;\n  line-height: 1.4;\n  font-size: 0.9rem;\n}\n\n.dark-mode .achievement-info p {\n  color: #bbb;\n}\n\n.achievement-details {\n  padding: 16px 20px 20px;\n}\n\n.achievement-progress {\n  margin-bottom: 12px;\n}\n\n.progress-bar {\n  height: 6px;\n  background: #ecf0f1;\n  border-radius: 3px;\n  overflow: hidden;\n  margin-bottom: 4px;\n  transition: background-color 0.3s ease;\n}\n\n.dark-mode .progress-bar {\n  background: #444;\n}\n\n.progress-fill {\n  height: 100%;\n  transition: width 0.5s ease;\n  border-radius: 3px;\n}\n\n.progress-text {\n  color: #7f8c8d;\n  font-size: 0.85rem;\n  text-align: right;\n}\n\n.dark-mode .progress-text {\n  color: #aaa;\n}\n\n.achievement-reward {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #f1c40f;\n  font-weight: 500;\n  margin-top: 12px;\n  font-size: 0.9rem;\n}\n\n.dark-mode .achievement-reward {\n  color: #f1c40f;\n}\n\n.reward-icon {\n  font-size: 1rem;\n}\n\n.completion-date {\n  font-size: 0.85rem;\n  color: #95a5a6;\n  font-style: italic;\n  margin-top: 8px;\n  text-align: right;\n}\n\n.dark-mode .completion-date {\n  color: #999;\n}\n\n.achievements-summary {\n  background: white;\n  padding: 24px;\n  border-radius: 16px;\n  margin-top: 32px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n}\n\n.dark-mode .achievements-summary {\n  background: #2d2d2d;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border-color: rgba(255, 255, 255, 0.05);\n}\n\n.achievements-summary h3 {\n  color: #2c3e50;\n  margin: 0 0 20px 0;\n  font-size: 1.2rem;\n  font-weight: 600;\n}\n\n.dark-mode .achievements-summary h3 {\n  color: #f5f5f5;\n}\n\n.summary-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 20px;\n}\n\n.summary-item {\n  text-align: center;\n}\n\n.summary-item span {\n  display: block;\n  color: #7f8c8d;\n  margin-bottom: 8px;\n  font-size: 0.9rem;\n}\n\n.dark-mode .summary-item span {\n  color: #aaa;\n}\n\n.summary-item strong {\n  font-size: 1.6rem;\n  color: #2c3e50;\n  font-weight: 700;\n}\n\n.dark-mode .summary-item strong {\n  color: #f5f5f5;\n}\n\n.no-achievements-message {\n  grid-column: 1 / -1;\n  text-align: center;\n  padding: 40px;\n  color: #7f8c8d;\n  font-size: 1.1rem;\n}\n\n.dark-mode .no-achievements-message {\n  color: #bbb;\n}\n\n@media (max-width: 768px) {\n  .achievements-container {\n    padding: 0;\n  }\n  \n  .achievements-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n  \n  .achievements-header h2 {\n    font-size: 1.6rem;\n  }\n  \n  .level-badge {\n    padding: 8px 16px;\n    font-size: 0.95rem;\n  }\n  \n  .stats-overview {\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 16px;\n  }\n  \n  .stat-card {\n    padding: 16px;\n  }\n  \n  .stat-icon {\n    font-size: 1.6rem;\n    margin-right: 12px;\n    padding: 10px;\n  }\n  \n  .stat-value {\n    font-size: 1.4rem;\n  }\n  \n  .achievements-categories {\n    margin-bottom: 24px;\n  }\n\n  .category-btn {\n    padding: 8px 16px;\n  }\n  \n  .achievements-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  \n  .summary-stats {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .achievement-card {\n    flex-direction: column;\n  }\n  \n  .achievement-icon {\n    margin-right: 0;\n    margin-bottom: 12px;\n    width: 40px;\n    height: 40px;\n    font-size: 1.5rem;\n  }\n  \n  .achievement-info h3 {\n    font-size: 1rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
